import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: { user: null, employee: null },
  reducers: {
    setUser: (state, action) => action.payload,
  },
});

const { setUser } = userSlice.actions;

export default userSlice.reducer;

export { userSlice, setUser };
